﻿import { EventAttendee, QuestionnaireStatusType, UploadedMedia } from '.';
import { Answer, copyAnswer } from './answer';
import { copyEventAttendee } from './event-attendee';
import { blankUploadedMedia, copyUploadedMedia } from './uploaded-media';
import { WinnerContact, blankWinnerContact, copyWinnerContact } from './winner-contact';

export interface Questionnaire {
  questionnaireId: number;
  winnerId: number;
  organizationId: number;
  status: QuestionnaireStatusType;
  mediaConsentDisclaimer?: boolean;
  contact: WinnerContact;
  eventAttendees: EventAttendee[];
  logo: UploadedMedia;
  media: UploadedMedia[];
  answers: Answer[];
}

export function blankQuestionnaire(): Questionnaire {
  return {
    questionnaireId: 0,
    winnerId: 0,
    organizationId: 0,
    status: 'Incomplete',
    mediaConsentDisclaimer: undefined,
    contact: blankWinnerContact(),
    eventAttendees: [],
    logo: blankUploadedMedia(),
    media: [],
    answers: [],
  };
}

export function copyQuestionnaire(questionnaire: Questionnaire): Questionnaire {
  const eventAttendees: EventAttendee[] = [];
  questionnaire.eventAttendees?.forEach(eventAttendee => {
    eventAttendees.push(copyEventAttendee(eventAttendee));
  });

  const media: UploadedMedia[] = [];
  questionnaire.media?.forEach(medium => {
    media.push(copyUploadedMedia(medium));
  })

  const answers: Answer[] = [];
  questionnaire.answers?.forEach(answer => {
    answers.push(copyAnswer(answer));
  })

  return {
    questionnaireId: questionnaire.questionnaireId,
    winnerId: questionnaire.winnerId,
    organizationId: questionnaire.organizationId,
    status: questionnaire.status,
    mediaConsentDisclaimer: questionnaire.mediaConsentDisclaimer,
    contact: questionnaire.contact ? copyWinnerContact(questionnaire.contact) : blankWinnerContact(),
    eventAttendees,
    logo: questionnaire.logo ? copyUploadedMedia(questionnaire.logo) : blankUploadedMedia(),
    media,
    answers,
  };
}
